/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PerturbedTextGenerationDataset
 */
export interface PerturbedTextGenerationDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedTextGenerationDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedTextGenerationDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedTextGenerationDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedTextGenerationDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedTextGenerationDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {Array<number>}
   * @memberof PerturbedTextGenerationDataset
   */
  documents?: Array<number>;
}

/**
 * Check if a given object implements the PerturbedTextGenerationDataset interface.
 */
export function instanceOfPerturbedTextGenerationDataset(value: object): value is PerturbedTextGenerationDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  return true;
}

export function PerturbedTextGenerationDatasetFromJSON(json: any): PerturbedTextGenerationDataset {
  return PerturbedTextGenerationDatasetFromJSONTyped(json, false);
}

export function PerturbedTextGenerationDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedTextGenerationDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    documents: json['documents'] == null ? undefined : json['documents'],
  };
}

export function PerturbedTextGenerationDatasetToJSON(
  value?: Omit<PerturbedTextGenerationDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    documents: value['documents'],
  };
}
